import { Routes, Route } from "react-router-dom";
import Grid from "@mui/material/Grid";
import NavBar from "./components/ui/NavBar";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { PageLayout } from "@front-ends/common/src/components/ui/PageLayout";
import { Profile } from "@front-ends/common/src/pages/Profile";
import { Home } from "./modules/EndPointLinnae/Home";
import { profileRequest as loginRequestLinnae} from "./authConfigLinnae";
import './services/i18n';

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps|any) {
  
  return (
    <MsalProvider instance={pca}>
      <PageLayout NavBar={NavBar}>
          <Grid container justifyContent="center">
              <Pages />
          </Grid>
      </PageLayout>
    </MsalProvider>
  )
}

function Pages() {
  return (
    <Routes>
      <Route path="/profile" element={<Profile loginRequest = {loginRequestLinnae}/>} />
      <Route path="/" element={<Home />} />
    </Routes>
  );
}

export default App